import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function BottomBar() {
  return (
    <div className="bottombarWide">
      <div className="flexbox">
        <div className="item">Chloe Can Code</div>
        <div className="item">Icons created by Freepik - Flaticon</div>
      </div>
    </div>
  );
}
